import React from "react";
import { useAuth } from "../hooks/useAuth";
import TwoFactor from "../components/Login/TwoFactor";

const TwoFactorAuth = () => {
  const { isAuthenticated, hasTwoFactorAuth, has2FASessionAccess } = useAuth();

  if (!isAuthenticated || !hasTwoFactorAuth || !has2FASessionAccess) {
    return window.location.assign("/");
  }

  return <TwoFactor />;
};

export default TwoFactorAuth;
